// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 870 ? "5c421772" : chunkId) + "." + {"829":"458cec82ed0cc8c4","870":"efb209f12f34b97b"}[chunkId] + ".js";
};